import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiEndpointsService } from './services/api-endpoints.service';
import { CecService } from './services/cec.service';

import { DataService } from './services/data.service';
import { PosService } from './services/pos.service';
import { PosWarningService } from './services/posWarning.services';
import { ApiInterceptorService } from './services/api-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptorSerice } from './services/loadding-interceptor.service';
import { ProductService } from './services/product.services';

@NgModule()
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ApiEndpointsService,
        DataService,
        PosService,
        CecService,
        PosWarningService,
        ApiInterceptorService,
        LoadingInterceptorSerice,
        ProductService,
        { provide: 'HttpService', useClass: environment.httpServiceType },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoadingInterceptorSerice,
          multi: true,
        },
      ],
    };
  }
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
